import { Component, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ProductConfigLayoutComponent } from 'fg-library';

@Component({
    selector: 'app-product-config-layout',
    templateUrl: './product-config-layout.component.html',
    styleUrls: ['./product-config-layout.component.scss'],
    standalone: false
})

export class FgClientProductConfigLayoutComponent extends ProductConfigLayoutComponent {

  @ViewChild('settingsDrawer') settingsDrawer!: MatDrawer;

  openSettingsDrawer() {
    this.settingsDrawer.open();
  }

  ngOnInit(): void {
    this.theming.theming$.subscribe(newTheme => {
      this.theming.theme = newTheme;
      this.currentTheme = newTheme;
    });

    super.ngOnInit();
  }
}
